import { useGenericSocket } from "@/hooks/useGenericSocket";
import { SocketTopics } from "@/lib/natsConnection";
import { useCallback } from "react";

// {"15m":0.32847603314500873,"1d":-17.366332831776674,"1h":0.7028128884127653,"1m":-0.30441439285000627,"30m":0.28570926012130826,"4h":6.216981030623401,"5m":-0.11507078884180544}
export interface IActivityDetectorResponse {
  "15m": number;
  "1d": number;
  "1h": number;
  "1m": number;
  "30m": number;
  "4h": number;
  "5m": number;
}

export function useAltMeter() {
  const handler = useCallback(
    (_: IActivityDetectorResponse, newData: IActivityDetectorResponse) => {
      return newData;
    },
    [],
  );

  return useGenericSocket<IActivityDetectorResponse>(
    SocketTopics.altTimer,
    handler,
  );
}
